// Component Name:  Upload Images component
// Author: Lavanya S
// Platform: Web
// OS: Windows
// IDE: Visual Studio Code
// Reference: Original
// Date:28-04-2025
// Description: This is a reusable component to upload images.
// Dependencies: React, redux
// Interfaces: Accepts props including selectedFiles, setSelectedFiles,warningToast
// Maintenance History:  1.0 - First Version

import React from "react";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import { Card, Col, Form, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { warningToast } from "../../store/dbFilter/actions";
import LKUploadImg from "../../assets/images/LK_Icons/LK_upload.svg";
import LKCloseImg from "../../assets/images/LK_Icons/LK_Close.svg";

const UploadImage = (props) => {
  const { selectedFiles, setSelectedFiles } = props;
  // to upload image
  const handleAcceptedFiles = (files) => {
    // Process each file
    const processedFiles = files.map((file) => {
      const preview = URL.createObjectURL(file);
      const fileSizeInBytes = file.size; // Get the file size in bytes
      const fileSizeInKB = fileSizeInBytes / 1024; // Convert bytes to KB
      if (fileSizeInKB > 500) {
        props.warningToast({ title: "Validation", message: "Image size must be under 500KB. Resize and try again" });
        return;
      }
      const formattedSize = formatBytes(file.size);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        // Once the conversion is done, you can use the base64 string.
        const base64Data = reader.result;
        setSelectedFiles([
          {
            name: file.name,
            size: formattedSize,
            preview,
            base64: file, // Base64 string added here
          },
        ]);
      };

      return {
        preview,
        formattedSize,
        name: file.name,
        size: formattedSize,
      };
    });
  };

  //   const handleAcceptedFiles = (files) => {
  //   const file = files[0]; // Assume single file for now
  //   const fileSizeInBytes = file.size;
  //   const fileSizeInKB = fileSizeInBytes / 1024;

  //   if (fileSizeInKB > 500) {
  //     props.warningToast({ title: "Validation", message: "Image size must be under 500KB. Resize and try again" });
  //     return;
  //   }

  //   const formattedSize = formatBytes(file.size);

  //   const reader = new FileReader();
  //   reader.readAsDataURL(file);
  //   reader.onload = (event) => {
  //     const img = new Image();
  //     img.src = event.target.result;

  //     img.onload = () => {
  //       const canvas = document.createElement("canvas");
  //       canvas.width = img.width;
  //       canvas.height = img.height;

  //       const ctx = canvas.getContext("2d");
  //       ctx.drawImage(img, 0, 0);

  //       // Convert to WebP
  //       canvas.toBlob((blob) => {
  //         if (!blob) {
  //           props.warningToast({ title: "Error", message: "Failed to convert image to WebP." });
  //           return;
  //         }

  //         const webpUrl = URL.createObjectURL(blob);

  //         const webpFile = new File([blob], file.name.replace(/\.[^/.]+$/, "") + ".webp", { type: "image/webp" });

  //         setSelectedFiles([
  //           {
  //             name: webpFile.name,
  //             size: formatBytes(webpFile.size),
  //             preview: webpUrl,
  //             base64: webpFile, // WebP file, ready for upload
  //           },
  //         ]);
  //       }, "image/webp", 0.8); // You can adjust quality (0.0 - 1.0)
  //     };
  //   };
  // };

  /**
   * Formats the size
   */
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  const handleRemoveImage = () => {
    setSelectedFiles([]);
  };
  return (
    <Form style={{ cursor: "pointer" }}>
      <Dropzone onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles)} accept=".jpeg, .png, .jpg">
        {({ getRootProps, getInputProps }) => (
          <div className="dropzone">
            <div className="dz-message needsclick mt-2 d-flex justify-content-center flex-column align-items-center" {...getRootProps()} style={{ height: "120px" }}>
              <input {...getInputProps()} />
              <div className="mb-3">
                {/* <i className="display-4 text-muted ri-upload-cloud-2-line"></i> */}
                <img
                  src={LKUploadImg}
                  alt="uploadImg"
                  style={{ width: props.layoutType === "vertical" ? "60px" : "40px", height: props.layoutType === "vertical" ? "60px" : "40px" }}
                />
              </div>
              {
                 props.layoutType === "vertical" ?<h4>Drop files here or click to upload.</h4>:<h5>Drop files here or click to upload.</h5>
              }
              
            </div>
          </div>
        )}
      </Dropzone>
      <div className="dropzone-previews mt-3" id="file-previews">
        {selectedFiles.map((f, i) => {
          return (
            <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete" key={i + "-file"}>
              <div className="p-2">
                <Row className="align-items-center">
                  <Col className="col-auto">
                    <img data-dz-thumbnail="" height="80" className="avatar-sm rounded bg-light" alt={f.name} src={f.preview} />
                  </Col>
                  <Col>
                    <Link to="#" className="text-muted font-weight-bold">
                      {f.name}
                    </Link>
                    <i className="ri-close-large-line"></i>
                    <p className="mb-0">
                      <strong>{f.formattedSize}</strong>
                    </p>
                  </Col>
                  <Col className="d-flex justify-content-end">
                    {/* <i className="ri-close-fill" style={{ fontSize: "24px", cursor: "pointer" }} onClick={handleRemoveImage}></i> */}
                    <img src={LKCloseImg} alt="closeImg" style={{ width: "18px", height: "18px", cursor: "pointer" }} onClick={handleRemoveImage} />
                  </Col>
                </Row>
              </div>
            </Card>
          );
        })}
      </div>
    </Form>
  );
};
const mapStateToProps = (state) => ({
  layoutType: state.Layout.layoutType,
});

const mapDispatchToProps = (dispatch) => ({
  warningToast: (payload) => dispatch(warningToast(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(UploadImage);
